import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStateService } from './services/session-state.service';
import jwt_decode from 'jwt-decode';

export const TOKEN_NAME: string = 'token';

@Injectable()
export class AuthGuard  {

  constructor(
    private router: Router, private session: SessionStateService) {}

  canActivate() {
    if (!this.isAuthenticated()) {
      this.router.navigate(['/']);
      return false;
    }
      return true;
  }

  getToken(): string {
    return this.session.getToken();
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_NAME, token);
  }

  getTokenExpirationDate(token: string): Date {
    const decoded:any = jwt_decode(token);

    if (decoded.exp === undefined) return null;

    const date = new Date(0); 
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token?: string): boolean {
    if(!token) token = this.getToken();
    if(!token) return true;
    
    const date = this.getTokenExpirationDate(token);
    if(date === undefined) return false;
    return (date.valueOf() < new Date().valueOf());
  }

  isAuthenticated(){
    if(!this.session.getState("userDetails")){
      console.log("not authenticated")
      return false;
    }
    return true;
  }

}